import { idToStrongId } from "@oysterhr/common"
import { companyBasePath } from "@oysterhr/router"

export const companyCreateBulkInvoicesPath = (companyId?: string) =>
  companyBasePath({ companyId, path: "invoices/bulk-upload" })

export const companyCreateBulkInvoicesResultsPath = ({
  companyId,
  backgroundProcessId,
}: {
  companyId?: string
  backgroundProcessId: string
}) =>
  companyBasePath({
    companyId,
    path: `invoices/bulk-upload/${idToStrongId(backgroundProcessId)}`,
  })

export const companyBulkUploadPrefilledTemplatePath = (companyId?: string) =>
  companyBasePath({
    companyId,
    path: "invoices/bulk-upload/download-prefilled-template",
  })

export const companyCreditNotesPath = (companyId: string, query?: string) => {
  return companyBasePath({ companyId, path: "invoices/creditnotes", query })
}
